export default "__VITE_ASSET__BZESJyEu__"